import { reduce } from "et3-type-guards";

export const toSubGroupFromCominParameter = <
  T extends { isKhattabaMessage: 1 | 0; isClientMessage: 1 | 0 } & Object
>(
  array: T[]
) => {
  let isKhattabaMessageOldValue = reduce(() => array[0].isKhattabaMessage, 0);
  let isClientMessageOldValue = reduce(() => array[0].isClientMessage, 0);
  let result: T[][] = [];
  let currentGroup: T[] = [];

  for (let i = 0; i < array.length; i++) {
    if (
      array[i].isKhattabaMessage === isKhattabaMessageOldValue &&
      array[i].isClientMessage === isClientMessageOldValue
    ) {
      currentGroup.push(array[i]);
    } else {
      result.push(currentGroup);
      currentGroup = [array[i]];
      isKhattabaMessageOldValue = array[i].isKhattabaMessage;
      isClientMessageOldValue = array[i].isClientMessage;
    }
    if (i === array.length - 1) {
      result.push(currentGroup);
    }
  }
  return result;
};
